
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/national-sales",
      function () {
        return require("private-next-pages/national-sales/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/national-sales"])
      });
    }
  